// Demo view is a gated preview of the client dashboard UI.
//
// It exists so the design can be reviewed without a live Supabase session or a
// tenant-bound BFF. Resolution order:
//
//   REACT_APP_ENABLE_DEMO_VIEW="true"   -> enabled
//   REACT_APP_ENABLE_DEMO_VIEW="false"  -> disabled, always wins
//   unset                               -> enabled only on a development server
//
// A production build therefore fails closed and never exposes a demo
// authentication path unless someone opts in explicitly. Demo view never calls
// the real /api surface, never holds a token, and never reports a mutation as
// successful.

export const DEMO_SESSION_KEY = "growthos.demo-view";
export const DEMO_SESSION_VALUE = "active";

export function isDemoViewEnabled(env = process.env) {
  const flag = String(env?.REACT_APP_ENABLE_DEMO_VIEW ?? "").trim().toLowerCase();
  if (flag === "true") return true;
  if (flag === "false") return false;
  return env?.NODE_ENV === "development";
}

export function readStoredDemoSession() {
  try {
    return window.sessionStorage.getItem(DEMO_SESSION_KEY) === DEMO_SESSION_VALUE;
  } catch {
    return false;
  }
}

export function persistDemoSession(active) {
  try {
    if (active) window.sessionStorage.setItem(DEMO_SESSION_KEY, DEMO_SESSION_VALUE);
    else window.sessionStorage.removeItem(DEMO_SESSION_KEY);
  } catch {
    // Session storage can be blocked. Demo view then lasts for this page view
    // only, which is an acceptable preview limitation.
  }
}
